/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box, Button, Divider, Typography, styled } from "@mui/material";

export const GuestOrderVisitsCard = styled(Box)({
  border: '1px solid #f0d8cb',
  borderRadius: '12px',
  backgroundColor: '#ffffff',
  boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
  padding: '18px 16px',
});

export const GuestOrderVisitsHeader = styled(Box)({
  marginBottom: '14px',
});

export const GuestOrderVisitsTitle = styled(Typography)({
  fontSize: '20px',
  lineHeight: 1.2,
  fontWeight: 700,
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
  textAlign: 'center',
  color: '#ff6b35',
});

export const GuestOrderVisitsSection = styled(Box)({
  display: 'grid',
  gap: '14px',
});

export const GuestOrderVisitsSubtitle = styled(Typography)({
  fontSize: '11px',
  lineHeight: 1.2,
  fontWeight: 700,
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
  textAlign: 'center',
  color: '#61748a',
});

export const GuestOrderVisitsPrimaryGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '12px',
});

export const GuestOrderVisitsMetricsRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'columns',
})(({ columns = 3 }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
  gap: '16px 12px',
  '@media (max-width: 420px)': {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
}));

export const GuestOrderVisitsSingleMetric = styled(Box)({
  display: 'grid',
  justifyItems: 'center',
  textAlign: 'center',
  gap: '4px',
});

export const GuestOrderVisitsValueItem = styled(Box)({
  display: 'grid',
  justifyItems: 'center',
  textAlign: 'center',
  gap: '4px',
  minWidth: 0,
});

export const GuestOrderVisitsValue = styled(Typography)({
  fontSize: '18px',
  lineHeight: 1.2,
  fontWeight: 700,
  color: '#233044',
  wordBreak: 'break-word',
});

export const GuestOrderVisitsValueLabel = styled(Typography)({
  fontSize: '11px',
  lineHeight: 1.35,
  fontWeight: 500,
  color: '#61748a',
});

export const GuestOrderVisitsDivider = styled(Divider)({
  margin: '16px 0',
  borderColor: '#dbe5f1',
});

export const GuestOrderVisitsLoadingWrap = styled(Box)({
  display: 'grid',
  gap: '12px',
});

export const GuestOrderVisitsEmptyState = styled(Typography)({
  fontSize: '13px',
  lineHeight: 1.4,
  color: '#61748a',
  textAlign: 'center',
  padding: '12px 0 4px',
});

export const GuestOrderVisitsErrorState = styled(Box)({
  display: 'grid',
  justifyItems: 'center',
  gap: '12px',
  fontSize: '13px',
  lineHeight: 1.4,
  color: '#61748a',
  textAlign: 'center',
  padding: '12px 0 4px',
});

export const GuestOrderVisitsRetryButton = styled(Button)({
  minWidth: '96px',
  textTransform: 'none',
  borderColor: '#ff6b35',
  color: '#ff6b35',
  fontWeight: 600,
  '&:hover': {
    borderColor: '#e85d2b',
    backgroundColor: 'rgba(255, 107, 53, 0.04)',
  },
});
